import { FavoriteRequests } from '@/services/http/favorites-requests';

export default {
  namespaced: true,
  state: {
    favorite: null,
    checkFields: null,
    favoritesShort: [],
    favoritesShortLoading: true,
    favoriteIdAutopayment: null,
    favorites: [],
    missingBulkAmount: null,
  },
  getters: {
    getFavoritesList(state) {
      return state.favorites;
    },
    getFavorite(state) {
      return state.favorite;
    },
    getMissingBulkAmount(state) {
      return state.missingBulkAmount;
    },
    getCheckFields(state) {
      return state.checkFields;
    },
    getLatestFavoritesShort(state) {
      return state.favoritesShort;
    },
    getFavoritesShortLoading(state) {
      return state.favoritesShortLoading;
    },
    getFavoriteIdAutopayment(state) {
      return state.favoriteIdAutopayment;
    },
  },
  mutations: {
    setFavoritesList(state, payload) {
      state.favorites = payload;
    },
    setFavorite(state, payload) {
      state.favorite = payload;
    },
    setMissingBulkAmount(state, payload) {
      state.missingBulkAmount = payload;
    },
    setCheckFields(state, payload) {
      state.checkFields = payload;
    },
    setLatestFavoritesShort(state, payload) {
      state.favoritesShort = payload?.data?.favorites?.content || [];
    },
    setFavoriteIdAutopayment(state, payload) {
      state.favoriteIdAutopayment = payload;
    },
    deleteFavoriteItem(state, deleteItem) {
      const modifiedList = state.favorites.filter((item) => item.id !== deleteItem.id);
      state.favorites = modifiedList;
    },
    resetMissingBulkAmount(state) {
      state.missingBulkAmount = null;
    },
  },
  actions: {
    setFavoritesList({ commit }, favorites) {
      commit('setFavoritesList', favorites);
    },
    setFavorite({ commit }, favorite) {
      commit('setFavorite', favorite);
    },
    async checkFavorite({ commit }, payload) {
      const data = await FavoriteRequests.checkFavorite(payload.id, payload.type);
      commit('setCheckFields', data);
      return data;
    },
    deleteFavoriteItem({ commit }, payload) {
      commit('deleteFavoriteItem', payload);
    },
    async getLatestFavoritesShort({ commit, state }) {
      state.favoritesShortLoading = true;
      const [response] = await FavoriteRequests.getFavorites(
        {
          filter: 'ALL',
          size: 5,
          page: 1,
        },
      );

      commit('setLatestFavoritesShort', response);
      state.favoritesShortLoading = false;
      return response;
    },
    setFavoriteIdAutopayment({ commit }, id) {
      commit('setFavoriteIdAutopayment', id);
    },
  },
};
